/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    /* Directive for the widget wrapper */
    angular.module('bm.practice.widgets.scrollingContainer', ['bmpScrollContainer'])
        .directive('bmPracticeWidgetScrollingContainer', [(): ng.IDirective => {
            return {
                restrict: 'E',
                transclude: true,
                templateUrl: 'practice-widgets/bm-practice-widget-scrolling-container/bm-practice-widget-scrolling-container.html',
                link: (scope: IBmPracticeWidgetScope, elem: ng.IAugmentedJQuery, attr: ng.IAttributes) => {

                    let currentPage = (scope.ctrl.loadDataArgs && scope.ctrl.loadDataArgs.pageIndex) || 1;
                    let loadingNextPage: boolean = false;

                    // Function for loading the next page of data
                    let loadNextPage = _.throttle(() => {
                        if (!loadingNextPage) {
                            if (scope.ctrl.hasMoreData) {
                                loadingNextPage = true;
                                currentPage++;
                                scope.ctrl.loadMoreData().then(() => { // TODO - ng161 - handle reject from loadMoreData
                                    currentPage = scope.ctrl.loadDataArgs.pageIndex;
                                    loadingNextPage = false;
                                });
                            }
                        }
                    }, 400);

                    // When the user scrolls to the bottom load the next page of data
                    let scrollableInner = elem.children();
                    scrollableInner.bind('scroll', (event: JQueryEventObject) => {
                        let outerHeight = scrollableInner.innerHeight();
                        let innerHeight = scrollableInner[0].scrollHeight;
                        let innerPosition = scrollableInner.scrollTop();
                        if (innerPosition + outerHeight + 30 > innerHeight) {
                            if (currentPage !== scope.ctrl.loadDataArgs.pageIndex) {
                                scrollableInner.scrollTop(0);
                                currentPage = scope.ctrl.loadDataArgs.pageIndex;
                            } else {
                                _.defer(() => {
                                    loadNextPage();
                                });
                            }
                        }
                    });

                }
            };
        }]);
}
